import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { localeAtom } from "@/state/locale.state";
import { formatLastSync } from "@/utils/format.utils.ts";
import { Trans } from "@lingui/react/macro";
import { useAtomValue } from "jotai";
import * as React from "react";

type UserSummaryProps = {
  name: string;
  avatarUrl?: string;
  initials: string;
  lastSync?: string | null;
  className?: string;
};

export function UserSummary({
  name,
  avatarUrl,
  initials,
  lastSync,
  className,
}: UserSummaryProps) {
  const locale = useAtomValue(localeAtom);
  const lastSyncText = React.useMemo(
    () => formatLastSync(locale, lastSync),
    [locale, lastSync],
  );

  return (
    <div
      className={["flex items-center gap-2", className]
        .filter(Boolean)
        .join(" ")}
    >
      <Avatar className="h-8 w-8 rounded-lg grayscale">
        <AvatarImage src={avatarUrl} alt={name} />
        <AvatarFallback className="rounded-lg">{initials}</AvatarFallback>
      </Avatar>

      <div className="grid flex-1 text-left text-sm leading-tight">
        <span className="truncate font-medium">{name}</span>
        <span className="truncate">
          <Trans>Last sync: {lastSyncText}</Trans>
        </span>
      </div>
    </div>
  );
}
